import React from 'react';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden" data-testid="hero-section">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: 'url(https://images.pexels.com/photos/104707/pexels-photo-104707.jpeg?auto=compress&cs=tinysrgb&w=1920)' }}
      />
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/75 to-black/60" />
      {/* Grain texture */}
      <div className="absolute inset-0 noir-grain" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 w-full">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 border border-red-700/50 bg-red-900/20 px-4 py-2 mb-8 animate-fadeIn" data-testid="hero-badge">
            <div className="w-2 h-2 bg-red-600 rounded-full" />
            <span className="text-xs uppercase tracking-[0.2em] text-gray-300">Cinematic Book Trailers</span>
          </div>

          {/* Main Headline */}
          <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-heading tracking-tighter uppercase leading-[0.9] mb-6 animate-fadeInUp" data-testid="hero-headline">
            <span className="text-white">Cinematic Book</span>
            <br />
            <span className="text-white">Trailers </span>
            <span className="text-gradient-noir">for</span>
            <br />
            <span className="text-gradient-noir">Thriller Authors</span>
          </h1>

          {/* Subheadline */}
          <p className="text-lg sm:text-xl text-gray-400 mb-10 max-w-xl leading-relaxed animate-fadeInUp" style={{ animationDelay: '0.2s' }} data-testid="hero-subheadline">
            We turn thriller novels into cinematic trailers that feel like <span className="text-red-500 font-semibold">real films</span>.
          </p>

          {/* CTA Button */}
          <div className="flex flex-col sm:flex-row items-start gap-4 animate-fadeInUp" style={{ animationDelay: '0.3s' }}>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-red-700 hover:bg-red-800 text-white font-bold uppercase tracking-[0.15em] text-sm px-8 py-4 group transition-colors duration-200 flex items-center"
              data-testid="hero-cta"
            >
              Send Your Synopsis
              <ArrowRight className="ml-3 group-hover:translate-x-1 transition-transform duration-200" size={18} />
            </button>
            <button
              onClick={() => scrollToSection('our-work')}
              className="border border-white/20 hover:border-white/40 hover:bg-white/5 text-white font-bold uppercase tracking-[0.15em] text-sm px-8 py-4 transition-all duration-200"
              data-testid="hero-secondary-cta"
            >
              See Our Work
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-5 h-9 border border-white/20 flex items-start justify-center p-1.5">
          <div className="w-0.5 h-2.5 bg-red-600" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
